module.exports = __webpack_public_path__ + "static/media/cases_ilustracoes_new08.02b22d06.jpg";